import { Button, SystemStyleObject } from "@chakra-ui/react";
import { Add, Trash } from "../../icons";

export function ListItemRemovalButton<T>({ onClick, sx }: { onClick: () => void, sx?: SystemStyleObject }) {
    return (
        <Button
            onClick={onClick}
            size={'sm'}
            colorScheme='secondary'
            variant={'outline'}
            _hover={{ backgroundColor: 'secondary.600', color: 'white' }}
            sx={sx}>
            <Trash boxSize={'16px'} />Odebrat
        </Button>
    )
}

export function ListItemAddedButton<T>({ onClick, sx }: { onClick: () => void, sx?: SystemStyleObject }) {
    return (
        <Button
            onClick={onClick}
            size={'sm'}
            colorScheme='primary'
            variant={'outline'}
            _hover={{ backgroundColor: 'primary.600', color: 'white' }}
            sx={sx}>
            <Add boxSize={'16px'} />Přidat
        </Button>
    )
}
